import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-input-pass-hide',
  templateUrl: './input-pass-hide.component.html',
  styleUrls: ['./input-pass-hide.component.css']
})
export class InputPassHideComponent implements OnInit {

  type: string = 'password';
  @Input('model')
  modelint: any;
  @Input()
  label: string = '';

  constructor() { }

  onShowHide() {
    this.type = this.type == 'password' ? 'text' : 'password';
  }
  change() {
    console.log("change " + this.modelint);
  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/input-pass-hide/input-pass-hide.component.ts